<template>
  <el-row>
    <el-col :span="8">
      <el-card shadow="never">
        <h3 slot="header">Order Details</h3>
        <log-on-header :header="order.header"/>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card shadow="never">
        <h3 slot="header">Order Items</h3>
        <ol>
          <log-on-detail v-for="(lineItem, index) in order.detail"
                         :key="index"
                         :detail="lineItem"/>
        </ol>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card shadow="never">
        <h3 slot="header">Paid</h3>
        <el-row>
          <el-col :span="8">Subtotal</el-col>
          <el-col :span="8">{{order.detail.length}} item(s)</el-col>
          <el-col :span="8" class="text-right">
            {{subtotal | currency}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">Shipping</el-col>
          <el-col :span="8">{{order.header.shipvia}}</el-col>
          <el-col :span="8" class="text-right">
            {{order.header.freight |currency}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">Tax</el-col>
          <el-col :span="8">{{order.header.taxcode}}</el-col>
          <el-col :span="8" class="text-right">
            {{order.header.tax |currency}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><strong>Total</strong></el-col>
          <el-col :span="12" class="text-right"><strong>
            {{total |currency}}</strong>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import {currency} from '../../filters';
  import LogOnHeader from './LogOnHeader';
  import LogOnDetail from './LogOnDetail';

  export default {
    name: 'LogOnOrderTable',
    props: {
      order: {
        type: Object,
        required: true,
        header: {
          required: true,
          type: Object,
          freight: {
            type: Number,
            default: 0,
          },
          shipvia: {
            required: true,
            type: String,
          },
          taxcode: {
            required: true,
            type: String,
          },
          tax: {
            type: Number,
            default: 0,
          },
          detail: {
            required: true,
            type: Object,
          },
        },
      },
    },
    components: {
      LogOnHeader,
      LogOnDetail,
    },
    filters: {
      currency,
    },
    computed: {
      subtotal: function() {
        return this.order.detail.reduce((total, item) => {
          return total + Number(item.unitprice);
        }, 0);
      },
      total: function() {
        return this.subtotal
          + Number(this.order.header.tax)
          + Number(this.order.header.freight);
      },
    },
  };
</script>

<style scoped>
  .el-card {
    margin: 0.5em;
    min-width: 300px;
  }
</style>
